import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1706Model } from './kymw1706.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { NotNullTextAreaComponent } from 'src/app/commons/kymw02/not-null-text-area/not-null-text-area.component';
import { UpdateC2pfStatusService } from '../kymw1700/api-services/update-c2pf-status.service';

/**
 * 差し戻し理由入力画面を管理するクラス
 *
 * @export KYMW1706Component
 * @class KYMW1706Component
 */
@Component({
  selector: 'app-kymw1706',
  templateUrl: 'kymw1706.component.html',
  styleUrls: ['kymw1706.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1706Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txta_RemandReason', { static: true }) txta_RemandReason: NotNullTextAreaComponent;
  public kymw1706Model: KYMW1706Model = new KYMW1706Model();
  public closeFunction: Function;

  /**
   * Creates an instance of KYMW1706Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPastImageInfoService} getPastImageInfoService
   * @param {RegistPastImageService} registPastImageService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1706Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public updateC2pfStatusService: UpdateC2pfStatusService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * @memberof KYMW1706Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1706';
  }

  /**
   * 親画面から値を設定する
   * @param guideGoodsName 
   * @param guideStandardName 
   * @param imageFileName 
   */
  public setParameter(guideGoodsName: string, guideStandardName: string, imageFileName: string): void {
    this.kymw1706Model.guideGoodsName = guideGoodsName;
    this.kymw1706Model.guideStandardName = guideStandardName;
    this.kymw1706Model.imageFileName = imageFileName;
  }

  /**
   * 差し戻し
   * @memberof KYMW1706Component
   */
  public eventClickHandler_Remand(): void {
    // 必須・属性・桁数チェック
    if (PlessViewUtilsSub.isEmpty(this.txta_RemandReason.text)) {
      this.dialogService.openAlertGetMessage('W0001', ['差し戻し理由']);
      return;
    }
    if (this.txta_RemandReason.text.length > 200) {
      this.dialogService.openAlertGetMessage('E0113', ['差し戻し理由'], null);
      return;
    }
    if (this.closeFunction !== undefined) {
      this.updateC2pfStatusService.execute([this.kymw1706Model.imageFileName], this.txta_RemandReason.text, '2', () => {
        this.closeFunction(this.txta_RemandReason.text);
        this.dialogService.openAlertGetMessage('I0106', ['差し戻しが完了'], () => {
          this.eventClickHandler_Close();
        });
      });
    }
  }

  /**
   * 画面を閉じる
   * @memberof KYMW1706Component
   */
  public eventClickHandler_Close(): void {
    this.closeFunction();
  }
}
